"use client";

import { useEffect, useState } from "react";

/** Share a venue: WhatsApp (Egypt's first channel), copy the link, or the phone's share sheet. */
export function GuideShareBar({
  url,
  text,
  copy,
}: {
  url: string;
  /** "Khufu's on Localized Egypt", the line that travels with the link. */
  text: string;
  copy: { title: string; whatsapp: string; copy: string; sheet: string; copied: string };
}) {
  const [copied, setCopied] = useState(false);
  const [canShare, setCanShare] = useState(false);
  // Read on the client after mount; the server renders without the share sheet.
  useEffect(() => setCanShare(typeof navigator.share === "function"), []);
  const whatsapp = `https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}`;
  return (
    <div className="eg-share" aria-label={copy.title}>
      <span className="eg-eyebrow" style={{ color: "var(--eg-muted)" }}>
        {copy.title}
      </span>
      <a href={whatsapp} target="_blank" rel="noopener noreferrer" className="eg-share__button eg-share__button--whatsapp">
        {copy.whatsapp}
      </a>
      <button
        type="button"
        className="eg-share__button"
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
          } catch {
            // Nothing to copy to.
          }
        }}
      >
        {copied ? copy.copied : copy.copy}
      </button>
      {canShare ? (
        <button
          type="button"
          className="eg-share__button"
          onClick={() => {
            navigator.share({ url, text, title: text }).catch(() => {
              // The visitor closed the sheet.
            });
          }}
        >
          {copy.sheet}
        </button>
      ) : null}
    </div>
  );
}
